<template>
    <div class="main-section home">
    <!--<p>INICIO > BEBES</p>-->
        <div class="row product-category-container">
            <div class="filter" >

                <hr><h3>Filtrar</h3><hr>
                <h3 data-field="component" class="filter-header" >Categorias
                <i v-if="category" class="fas fa-plus fa-xs"  @click="OpenCategory()"/>
                <i v-if="!category" class="fas fa-minus fa-xs"  @click="OpenCategory()"/>
                </h3>
                <div class="slider" :class="{'closed':category}">
                    <h4 class="filter-content pointer" v-for="(data,index) in filterCategories" :key="index" @click="FilterProduct({key:'category', filter:data.id,productSlug:data.slug})">{{data.name}}</h4>
                </div>
                <hr>
                <h3 class="filter-header">Tipo</h3>
                <h4 class="filter-content pointer" @click="FilterProduct({key:'type', filter:'0'})">De marca</h4>
                <h4 class="filter-content pointer" @click="FilterProduct({key:'type', filter:'1'})">Genérico</h4><hr>

                <h3  data-field="component" class="filter-header">Por componente
                <i v-if="component" class="fas fa-plus fa-xs"  @click="OpenComponent()"/>
                <i v-if="!component" class="fas fa-minus fa-xs"  @click="OpenComponent()"/>
                </h3>
                <div class="slider" :class="{'closed':component}">
                    <h4 class="filter-content pointer" v-for="(data,index) in filterComponents" :key="index" @click="FilterProduct({key:'component', filter:data.id})">{{data.name}}</h4>
                </div>
                <hr>

                <h3  data-field="component" class="filter-header">Restricciones 
                <i v-if="restriction" class="fas fa-plus  fa-xs" @click="OpenRestriction()"/>
                <i v-if="!restriction" class="fas fa-minus  fa-xs"  @click="OpenRestriction()"/>
                </h3>
                <div class="slider" :class="{'closed':restriction}">
                    <h4 class="filter-content pointer" @click="FilterProduct({key:'prescription', filter:'0'})">Sin receta</h4>
                    <h4 class="filter-content pointer" @click="FilterProduct({key:'prescription', filter:'1'})">Con receta</h4><hr>
                </div>
                <hr>
            </div>

            <div class="products-container" v-if="filterProducts!==null">
                <div class="products-header-info">
                    <h1 align="left" class="product-header-info-align" v-if="filterProducts"><span v-for="(data,index) in filterProducts[0].categories" :key="index">{{data.name}} <span v-if="index < filterProducts[0].categories.length - 1"> / </span></span></h1>
                    <div class="product-sub-header-info-align" >
                        <p align="left" class="product-header-info-align">{{filterProducts.length}} productos</p>
                        <div class="product-header-filer">
                            <select name="sortBy" id="sortBy" class="form-control"  @change="Filter">
                                <option value="" selected disabled>Ordenar por</option>
                                <option value="name">Nombre</option>
                                <option value="price">Precio</option>
                            </select>
                        </div>
                    </div>
                    <div id="NarrowMenu" class="narrow-menu" :class="{'active':showFilterMenu}">
                        <i class="fas fa-times fa-2x left-upper-corner" name="upperCornerIcon" id="upperCornerIcon" @click="ShowFilterMenu()"/>
                        <div class="categories-container pointer"  
                            @click="ShowFilter(0)">Ordenar por
                            <div v-if="filterIndex === 0" :class="{'active-sub-categories':false}">
                                <div class="sub-categories pointer" @click="FilterProduct({key:'sortBy',filter:'name'})">Nombre</div>
                                <div class="sub-categories pointer" @click="FilterProduct({key:'sortBy',filter:'price'})">Precio</div>
                            </div>
                        </div>
                        <div class="categories-container pointer"  
                            @click="ShowFilter(1)">Categorias
                            <div v-if="filterIndex === 1" :class="{'active-sub-categories':false}">
                                <div class="sub-categories pointer" v-for="(data,index) in filterCategories" :key="index" @click="FilterProduct({key:'category', filter:data.id,productSlug:data.slug})">{{data.name}}</div>
                            </div>
                        </div>
                        <div class="categories-container pointer"  
                            @click="ShowFilter(2)">Componente
                            <div v-if="filterIndex === 2" :class="{'active-sub-categories':false}">
                                <div class="sub-categories pointer" v-for="(data,index) in filterComponents" :key="index" @click="FilterProduct({key:'component', filter:data.id})">{{data.name}}</div>
                            </div>
                        </div>
                        <div class="categories-container pointer"  
                            @click="ShowFilter(3)">Restricciones
                            <div v-if="filterIndex === 3" :class="{'active-sub-categories':false}">
                                <div class="sub-categories pointer"  @click="FilterProduct({key:'prescription', filter:'0'})">Si receta</div>
                                <div class="sub-categories pointer"  @click="FilterProduct({key:'prescription', filter:'1'})">Con receta</div>
                            </div>
                        </div>
                        <div class="categories-container pointer"  
                            @click="ShowFilter(4)">Tipo
                            <div v-if="filterIndex === 4" :class="{'active-sub-categories':false}">
                                <div class="sub-categories pointer"  @click="FilterProduct({key:'type', filter:'0'})">De marca</div>
                                <div class="sub-categories pointer"  @click="FilterProduct({key:'type', filter:'1'})">Generico</div>
                            </div>
                        </div>
                    </div>
                    <div class="hide-filter">
                        <button @click="ShowFilterMenu">Filtrar</button>  
                    </div>
                </div>
      
                <div class="products-grid row wrap">
                    <div class="box-product columns space-around product-hover-card center" v-for="(product,index) in filterProducts" :key="index" v-on:click="ProductDetail(product)" v-on:mouseover="HoverIndex(index)" v-on:mouseleave="HoverIndex(-1)">
                        <div class="pointer" @click="GetProductBySlug(product.slug)">
                            <img onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';" :alt="product.slug" :src="'https://images.gofarma.com.mx/'+product.sku+'-1.jpeg'">
                            <div class="parent-container">
                                <div class="product-container">
                                    <p class="product-name">{{product.name}}</p>
                                </div>
                            </div>

                            <div class="product-info">
                                <!-- If product has discount -->
                                <div v-if="product.basePrice !== product.lowerIndividualPriceForWeb">
                                    <span class="discount-cost">{{product.basePrice | to-currency}}</span><br>
                                    <span class="cost">{{product.lowerIndividualPriceForWeb | to-currency}}</span>
                                    <span class="today-only">SOLO HOY</span>
                                </div>

                                <!-- If product has no discounts -->
                                <div v-else>
                                    <span class="cost">{{product.basePrice | to-currency}}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Desktop and tablet buttons -->
                        <button v-if="hoverIndex===index" class="btn" :class="product.available ? 'btn-primary' : 'btn-light'" @click="AddRawProduct( {product: product, quantity: 1} )" data-not-narrow-mode>
                            <span class="bold" v-if="product.available" style="color: white">Agregar al carrito</span>
                            <span class="bold" v-else style="color: white">Sobre pedido</span>
                        </button>

                        <!-- Mobile only button -->
                        <button class="btn" :class="product.available ? 'btn-primary' : 'btn-light'" @click="AddRawProduct( {product: product, quantity: 1} )" data-not-wide-mode data-not-medium-mode>
                            <span class="bold" v-if="product.available" style="color: white">Agregar al carrito</span>
                            <span class="bold" v-else style="color: white">Sobre pedido</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="center" >
            <div class="large-container">
                <img src="img/Modalidades.png" alt=""  class="modality">
            </div>   
        </div>
    </div>   
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    name:'FilterProduct',
    data(){
        return{
          categoryFilter:null
        }
    },
    methods:{
        OpenCategory(){
            let category = !this.category
            this.$store.commit('StateAssign',{category})
        },
        OpenComponent(){
            let component = !this.component
            this.$store.commit('StateAssign',{component})
        },
        OpenRestriction(){
            let restriction = !this.restriction
            this.$store.commit('StateAssign',{restriction})
        },
        HoverIndex(index){
            let hoverIndex = index
            this.$store.commit('StateAssign',{hoverIndex})
        },
        beforePageDestroyed: function () {
 
        },
        ShowFilterMenu(){
            let showFilterMenu = !this.showFilterMenu
            this.$store.commit("StateAssign",{showFilterMenu})
        },
        ShowFilter(index){
            let filterIndex = index==this.filterIndex? -1:index
            this.$store.commit("StateAssign",{filterIndex})
        },
        Filter(e){
            let filter
            let key
            if(e.target.name =='category'){
                key = e.target.name
                filter = this.categoryFilter.name
                let slug = this.categoryFilter.slug
                this.$store.dispatch('FilterProduct',{key,filter})
            }else{
                key = e.target.name
                filter = e.target.value
                this.$store.dispatch('FilterProduct',{key,filter})
            }
               
        },
        ...mapActions(['ProductDetail','FilterProduct','AddRawProduct','GetProductBySlug'])
    },
    computed: {
        ...mapState([
            'filterProducts',
            'filterCategories',
            'filterComponents',
            'hoverIndex',
            'category',
            'component',
            'restriction',
            'showFilterMenu',
            'filterIndex']),
        }
}
</script>
<style >
.slider {
	overflow-y: hidden;
	height: auto; /* approximate max height */

	transition-property: all;
	transition-duration: 1s;
	
}
.orders-info-footer{
    display: flex;
    justify-content: space-around;
    flex-grow: 1;
    flex-direction: row;
    flex-wrap: wrap;
}
.products-container{
    width: 85%;
}
.filter{
    flex-basis: 15%;
}
.responsive-filter{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-left:2rem;
}

.responsive-filter-content{
    margin-left:1rem;
    margin-top:1rem;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    line-height: 1.6;
    background-color: #fff;
    text-align: center;
    box-sizing: border-box;
}

@media (min-width: 64.0625rem) {
    .hide-filter{
        display: none;
    }
}

@media (max-width:64.0625rem){
    .product-header-filer{
        display: none;
    }
}

.filter-header{
    text-align:left;
}

.fa-plus, .fa-minus{
    float:right;
}

.filter-content{
    text-align:left;padding-left:.5em;
}

.product-category-container{
    align-items: flex-start;
    justify-content: flex-start;
}

.slider.closed {
	max-height: 0;
}

.products-header-info{
    display:flex;
    flex-direction:column;
}

.product-header-info-align{
    padding-left:3rem;
}

.product-sub-header-info-align{
    display:flex;
    justify-content:space-between;
}

.product-header-filter{
    display:flex;
    justify-content:flex-end;
}

.form-control {
    width: 100%;
    min-height: 2rem;
    padding: 0.3125rem 0.625rem;
    line-height: 1.6;
    background-color: #fff;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    outline: 0;
    margin-bottom:1em;
    text-align: center;
    box-sizing : border-box;
}

@media(max-width: 64.0625rem){
  .filter{
    visibility: hidden;
    width: 0rem;
  }
  .products-container {
    width: 100%;
    }
}

@media screen and (max-width: 26.25rem) {
  
    .truck {
        display: none !important;
    }

    .cart {
        width: 100% !important;
        right: -100%;
    }

    .narrow-menu {
        width: 100% !important;
        left: -100%;
    }

    .header-phones {
        font-size: 5vw !important;
    }
}

@media screen and (min-width: 26.25000000000625rem) and (max-width: 64rem) {
    [data-not-medium-mode] {
        display: none !important;
    }

    .cart {
        width: 60% !important;
        right: -60%;
    }

    .narrow-menu {
        width: 60% !important;
        left: -60%;
    }

    .header-phones {
        font-size: 3vw !important;
    }
}

@media(max-width: 62.5rem){
    
    .product-prices{
        display:inline-block !important;
    }
    .product-card-name{
        max-width:100% !important;
        display:inline-block!important;
        padding-bottom:1.25rem;
    }
}

@media(max-width: 78.125rem){
    
    .footer-links{
        font-size: 2.7vw;
    }
    .slider-video{
        width: 48.75rem !important;
        height: 18.75rem !important;
    }
}

@media(max-width: 68.75rem){
    .myfooter{
        min-height: 38.75rem !important;
        height: 38.75rem !important;
    }
}

@media(max-width: 64.0625rem){
    .footer-phones{
        margin-bottom:1.5625rem !important;
    }
    .slider{
        margin-top: -3.4375rem !important;
    }

    .filter-button{
        display: flex !important;
    }

    .filter{
        display: none !important;
        visibility: hidden
    }

    .sorters{
        justify-content: center !important;
    }
    .slider-video{
        width: 40rem !important;
        height: 18.75rem !important;
    }
}

@media(max-width: 55rem){
    .slider-video{
        width: 31.25rem !important;
        height: 18.75rem !important;
    }
}

@media(max-width: 46.875rem){
    .slider-video{
        width: 46.875rem !important;
        height: 18.75rem !important;
    }
}

@media(max-width: 41.5625rem){
    .row.start{
        justify-content: center !important;
    }
    .text-right{
        text-align: center !important;
    }
    .cart-button{
        width:100% !important;
        margin-top: 0.75rem;
    }
    .slider{
        margin-top: -6.25rem !important;
        margin-bottom: -4.375rem !important;
    }
    .slider-video{
        width: 18.75rem !important;
        height: 11.25rem !important;
    }
    .post-container {
        position: relative;
        min-height: 16.25rem;
        overflow: hidden;
    }
    .footer-header{
        width: 100%;
        display: inline-block;
        text-align: center;
    }

    .header-text{
        margin: 0;
        font-size: 6.5vw !important;
    }

    span.gofarma-text-aqua{
        font-size: 11vw !important;
    }

    span.gofarma-text-aqua span{
        font-size: 11vw !important;
    }

    .myfooter{
        height:61.25rem !important;
    }

    .footer-link-wrapper{
        display: block !important;
    }

    .footer-links{
        font-size: 1.75rem !important;
    }

    .footer-links-container{
        align-items: center !important;
    }

    .post-container{
        padding: 0 !important;
        text-align: center;
    }

    .footer-phones div span{
        font-size: 3.5vw !important;
    }

    .footer-phones div{
        margin-left: 5vw !important;
    }

    iframe{
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}

@media(max-width: 33.75rem){
    .header-text{
        margin: 0;
        font-size: 7.5vw !important;
    }

    span.gofarma-text-aqua{
        font-size: 15vw !important;
    }

    span.gofarma-text-aqua span{
        font-size: 15vw !important;
    }

    .sorters{
        display: block !important;
       
    }

    .sorters div{
        display: block !important;
        width: 100%;
        border-radius: 0 !important;
    }
}


@media(min-width: 64.0625rem){
    .header-text{
        margin: 0;
        font-size: 7.5vw !important;
    }

    span.gofarma-text-aqua{
        font-size: 15vw !important;
    }

    span.gofarma-text-aqua span{
        font-size: 15vw !important;
    }

    .sorters{
        display: block !important;
        visibility: hidden;
        height:0rem;
    }

    .sorters div{
        display: block !important;
        width: 100%;
        border-radius: 0 !important;
    }
}


@media(max-width: 26.25rem){
    .home, .main-section{
        padding: 0 !important;
    }

    .footer-info{
        font-size: 1rem !important;
    }

    .product-prices{
        font-size: 1.125rem !important;
        justify-content: center !important;
    }

    .product-details{
        display: inherit !important;
    }
}

@media(max-width: 24.1875rem){
    .grid-container{
        display: inherit !important;
    }

    .search-bar{
        font-size: 0.75rem;
    }
}

/*@media screen and (min-width:64.06250000000625rem) {
    [data-not-wide-mode] {
        display: none !important;
    }
}*/

@media(min-width: 96.875rem){
    ol, ul{
        font-size: 1.5vw;
    }
    .header-text{
        font-size: 3.5vw !important;
    }
}
@media (min-width: 112.5rem) {
    ol, ul{
        font-size: 1.3vw;
    }
    .contact{
        font-size:.9vw;
    }
    .gofarma-text-aqua{
        font-size: 2vw !important;
    }
    .gofarma-text-smaller-aqua{
        font-size: 1vw !important;
    }
    .line{
        font-size: 2vw !important;
    }
}
@media (min-width: 150rem){
    ol, ul{
        font-size: 1.0vw;
    }
    .header-text{
        font-size: 2.3vw !important;
        margin-left: 18.75rem !important;
    }
    .contact{
        font-size:.6vw;
    }
}
@media (min-width: 181.25rem){
    ol, ul{
        font-size: 0.6vw;
    }
    .contact{
        font-size:.5vw;
    }
}

</style>
